// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/ua'

// Translation: Model > Phone number verifier (Ukrainian)
export default Object.freeze({
	actions: {
		verify: ''
	},
	components: { phoneVerificationDialog }
})
